module.exports = __webpack_public_path__ + "static/img/logo.c3f4c8d4.png";